const FilterCaption = ({filterModel}) => {
  const opened_filter_caption = filterModel['openedDt']
    ? `Displaying cases initiated in ${filterModel['openedDt'].state}`
    : '';
  const closed_filter_caption = filterModel['closedDt']
    ? `Displaying cases closed in ${filterModel['closedDt'].state}`
    : '';
  const order_filter_caption = filterModel['orderDt']
    ? `Displaying orders issued in ${filterModel['orderDt'].state}`
    : '';

  let filter_caption = '';
  if (opened_filter_caption && closed_filter_caption)
    filter_caption = `${opened_filter_caption} & ${closed_filter_caption}`;
  filter_caption ||= opened_filter_caption || closed_filter_caption || order_filter_caption;
  return filter_caption ? <p id="year-filter-caption">{filter_caption}</p> : <></>;
};

export default FilterCaption;
